import { render, staticRenderFns } from "./ButtonExport.vue?vue&type=template&id=f20d3234&scoped=true"
import script from "./ButtonExport.vue?vue&type=script&lang=js"
export * from "./ButtonExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20d3234",
  null
  
)

export default component.exports